import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer/footer.component';
import { HeaderComponent } from './header/header/header.component';
import { MainHeaderComponent } from './header/main-header/main-header.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ToggleButtonComponent } from 'src/app/shared-layout/Components/toggle-button/toggle-button.component';
import { MobileHeaderComponent } from 'src/app/shared-layout/header/mobile-header/mobile-header.component';
import { FooterLowerComponent } from 'src/app/shared-layout/footer/footer-lower/footer-lower.component';
import { FooterCopyRightComponent } from 'src/app/shared-layout/footer/footer-copy-right/footer-copy-right.component';
import { FooterUpperComponent } from 'src/app/shared-layout/footer/footer-upper/footer-upper.component';
import { SearchFieldComponent } from 'src/app/shared-layout/Components/search-field/search-field.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DropDownComponent } from 'src/app/shared-layout/Components/drop-down/drop-down.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CognitoUtil } from 'src/app/shared/utils/cognito.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { Utility } from 'src/app/shared/utils/utility.service';
import { MobileDropDownComponent } from 'src/app/shared-layout/Components/mobile-drop-down/mobile-drop-down.component';
import { TokenInterceptorModule } from 'src/app/libs/ui/interceptors/token';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PageLoaderComponent } from 'src/app/shared-layout/Components/page-loader/page-loader.component';
import { LoaderInterceptorModule } from 'src/app/libs/ui/interceptors/loader/src/loader-interceptor.module';
import { ModalItemViewComponent } from 'src/app/shared-layout/Components/modal-item-view/modal-item-view.component';
import { EmptyDetailsComponent } from 'src/app/shared-layout/Components/empty-details/empty-details.component';
import { BaseHeaderComponent } from 'src/app/shared-layout/header/base-header/base-header.component';
import { AccessControlModule } from '../libs/ui/directives/access-control/access-control.module';
import { RouterModule } from '@angular/router';
import { ControlDisabledDirectiveModule } from '../libs/ui/directives/control-disabled/control-disabled-directive.module';
import { ConfirmDialogComponent } from './Components/confirm-dialog/confirm-dialog.component';
import { ConfirmRemoveDialogComponent } from './Components/confirm-remove-dialog/confirm-remove-dialog.component';
import { AlertDialogComponent } from './Components/alert-dialog/alert-dialog.component';
import { AccountSettingsModule } from './header/account-settings/account-settings.module';
import { NestedLoaderComponent } from './Components/page-loaders/nested-loader/nested-loader.component';
import { ExpireTimeFormatPipe } from '../libs/ui/pipes/expire-time.pipe';
import { NgPipesModule } from 'ngx-pipes';
import { RestrictRemoveDialogComponent } from './Components/restrict-remove-dialog/restrict-remove-dialog.component';
import { DateRangePickerComponent } from './Components/date-range-picker/date-range-picker.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DashboardUserCardComponent } from './Components/dashboard-user-card/dashboard-user-card.component';
import { DashboardUnitCardComponent } from './Components/dashboard-unit-card/dashboard-unit-card.component';
import { DashboardDeviceCardComponent } from './Components/dashboard-device-card/dashboard-device-card.component';
import { DashboardShareAccessCardComponent } from './Components/dashboard-share-access-card/dashboard-share-access-card.component';
import { DashboardDefaultCardComponent } from './Components/dashboard-default-card/dashboard-default-card.component';
import { ViewAllSharedAccessComponent } from './Components/dashboard-share-access-card/view-all-shared-access/view-all-shared-access.component';
import { ViewAllAvailableUnitsComponent } from './Components/dashboard-unit-card/view-all-available-units/view-all-available-units.component';
import { SharedLockDevicesListComponent } from './Components/shared-lock-devices-list/shared-lock-devices-list.component';
import { SortByModule } from '../libs/ui/pipes/sort-by/sort-by.module';
import { SharedUnitUsersListComponent } from './Components/shared-unit-users-list/shared-unit-users-list.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ParsedDateTimeModule } from '../libs/ui/pipes/parsed-date-time/parsed-date-time.module';
import { SpinnerLoaderComponent } from './Components/page-loader/spiner-loader/spinner-loader.component';
import { ParsedTimeModule } from '../libs/ui/pipes/parsed-time/parsed-time.module';
import { SharedAccesspointDevicesListComponent } from './Components/shared-accesspoint-devices-list/shared-accesspoint-devices-list.component';
import { DeviceLockImageModule } from '../libs/ui/pipes/device-lock-image/device-lock-image.module';
import { ProfilePictureModule } from './Components/profile-picture/profile-picture.module';
import { CheckSelectionListComponent } from './Components/check-selection-list/check-selection-list.component';
import { HideAccessModule } from '../libs/ui/directives/hide-access/hide-access.module';
import { WithTooltipModule } from './Components/with-tooltip/with-tooltip.module';
import { DashboardRemainingInvitationsCardComponent } from './Components/dashboard-remaining-invitations-card/dashboard-remaining-invitations-card.component';
import { RemainingInviteDialogComponent } from './Components/remaining-invite-dialog/remaining-invite-dialog.component';
import { LocalizationService } from '../shared/services/localization.service';
import { NotFoundComponent } from './Components/not-found/not-found.component';
import { VersionInfoDialogComponent } from './footer/footer-lower/version-info/version-info.component';
import { ProfilePictureWithStatusComponent } from './Components/profile-picture-with-status/profile-picture-with-status.component';
import { RemoveUserFromUnitComponent } from './Components/remove-user-from-unit/remove-user-from-unit.component';
import { SupportModalComponent } from './header/support/support-modal/support-modal.component';
import { EmailSupportModalComponent } from './header/support/email-support-modal/email-support-modal.component';
import { VersionBannerComponent } from './Components/version-banner/version-banner.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    VersionInfoDialogComponent,
    FooterComponent,
    HeaderComponent,
    BaseHeaderComponent,
    MainHeaderComponent,
    MobileHeaderComponent,
    ToggleButtonComponent,
    FooterLowerComponent,
    FooterCopyRightComponent,
    FooterUpperComponent,
    SearchFieldComponent,
    DropDownComponent,
    MobileDropDownComponent,
    PageLoaderComponent,
    SpinnerLoaderComponent,
    ModalItemViewComponent,
    EmptyDetailsComponent,
    ConfirmDialogComponent,
    ConfirmRemoveDialogComponent,
    AlertDialogComponent,
    NestedLoaderComponent,
    ExpireTimeFormatPipe,
    RestrictRemoveDialogComponent,
    DateRangePickerComponent,
    DashboardUserCardComponent,
    DashboardUnitCardComponent,
    DashboardDeviceCardComponent,
    DashboardShareAccessCardComponent,
    DashboardDefaultCardComponent,
    ViewAllSharedAccessComponent,
    ViewAllAvailableUnitsComponent,
    SharedLockDevicesListComponent,
    SharedAccesspointDevicesListComponent,
    SharedUnitUsersListComponent,
    CheckSelectionListComponent,
    DashboardRemainingInvitationsCardComponent,
    RemainingInviteDialogComponent,
    NotFoundComponent,
    ProfilePictureWithStatusComponent,
    RemoveUserFromUnitComponent,
    SupportModalComponent,
    EmailSupportModalComponent,
    VersionBannerComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonToggleModule,
    MatTooltipModule,
    WithTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    NgbModule,
    MatSelectModule,
    HttpClientModule,
    MatDatepickerModule,
    ParsedDateTimeModule,
    ParsedDateTimeModule,
    TokenInterceptorModule,
    MatProgressSpinnerModule,
    LoaderInterceptorModule,
    ControlDisabledDirectiveModule,
    AccessControlModule,
    AccountSettingsModule,
    RouterModule,
    NgPipesModule,
    SortByModule,
    InfiniteScrollModule,
    ParsedTimeModule,
    DeviceLockImageModule,
    ProfilePictureModule,
    HideAccessModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    BaseHeaderComponent,
    SearchFieldComponent,
    PageLoaderComponent,
    ModalItemViewComponent,
    EmptyDetailsComponent,
    ConfirmDialogComponent,
    NestedLoaderComponent,
    SpinnerLoaderComponent,
    ExpireTimeFormatPipe,
    NgPipesModule,
    RestrictRemoveDialogComponent,
    DateRangePickerComponent,
    DashboardUserCardComponent,
    DashboardUnitCardComponent,
    DashboardDeviceCardComponent,
    DashboardShareAccessCardComponent,
    DashboardDefaultCardComponent,
    SharedLockDevicesListComponent,
    SharedAccesspointDevicesListComponent,
    SharedUnitUsersListComponent,
    InfiniteScrollModule,
    CheckSelectionListComponent,
    DashboardRemainingInvitationsCardComponent,
    RemainingInviteDialogComponent,
    ProfilePictureWithStatusComponent,
    VersionBannerComponent,
  ],
  providers: [
    CognitoUtil,
    StateManagementService,
    Utility,
    LocalizationService,
    TranslateModule,
  ],
})
export class SharedLayoutModule {}
